import { render, staticRenderFns } from "./block-main.vue?vue&type=template&id=cbdb048a&scoped=true&"
import script from "./block-main.vue?vue&type=script&lang=js&"
export * from "./block-main.vue?vue&type=script&lang=js&"
import style0 from "./block-main.vue?vue&type=style&index=0&id=cbdb048a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb048a",
  null
  
)

export default component.exports